(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pf-liebe-kapitel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.documentElement;
    if (!root.classList.contains('pf-lp-js')) return;
    var items = document.querySelectorAll('.pf-lp-reveal');
    var showAll = function () { items.forEach(function (el) { el.classList.add('is-visible'); }); };
    if (!('IntersectionObserver' in window)) { showAll(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
    // Anchor jumps: show target content immediately
    window.addEventListener('hashchange', function () {
      var t = document.getElementById(location.hash.slice(1));
      if (t) t.querySelectorAll('.pf-lp-reveal').forEach(function (el) { el.classList.add('is-visible'); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
